(function (window) {
  /**
   * Fetches an SVG icon given some options such as a template, fill color,
   * and text. It will return a Google Maps Marker options hash compatible
   * object so you can use just like:
   * `new google.maps.Marker({icon: BatchGeoSvgMarkerIcon(...)})`
   *
   * You can easily use this for <img>s and background-url's. Just take the url
   * property from the returned object. It will also return a "scaledSize"
   * property which is a Google Maps Size instance. The scaledSize property is
   * important for IE support.
   *
   * NOTE: When using this it is highly recommended to turn off the optimized
   * flag in the Marker options like:
   *
   * new google.maps.Marker({
   *   icon: BatchGeoSvgMarkerIcon(...),
   *   optimized: false
   * })
   *
   * @param {object} options An object hash containing the following options:
   *   @param {string} options.type The type of marker SVG to generate. See the
   *   BatchGeoSvgMarkerIconTemplates file for the supported types.
   *   @param {object} options.template This object contains the properties you
   *   want to use to generate an image. Currently supported props are: fill,
   *   width, height, and text.
   * @returns {object} A Google Maps Marker options compatible object.
   *
   * @constructor
   */
  var BatchGeoSvgMarkerIcon = function (options) {
    var settings = _.merge(
      {
        // If no type is given we default to this
        type: "pushpinPlain",
        template: {
          text: "", // passing a value here doesn't reflect on the markers?
        },
      },
      options,
    );
    // According to the following link, if possible, returning a url here would improve marker/map load time.
    // may not be possible sense we want to send extra options with our custom Icon()
    // https://stackoverflow.com/questions/53429911/marker-load-time-is-10x-slower-when-icon-parameter-is-passed-valid-or-not
    if (!settings.template.stroke) settings.template.stroke = "black";

    if (!settings.template.opacity) settings.template.opacity = 1;

    return {
      url:
        BatchGeoStore.getState().App.staticNodeServiceBaseUrl +
        "/marker/png?type=" +
        settings.type +
        "&size=" +
        settings.template.width +
        "&fill=" +
        settings.template.fill +
        "&stroke=" +
        settings.template.stroke +
        "&text=" +
        settings.template.text +
        "&opacity=" +
        settings.template.opacity,
      scaledSize: new google.maps.Size(
        settings.template.width,
        settings.template.height,
      ),
    };
  };

  window.BatchGeoSvgMarkerIcon = BatchGeoSvgMarkerIcon;
})(window);
